import { Box, Stack } from '@mantine/core';
import { SettingsSwitch } from '@repo/common/components';
import { useAuthUser } from '../../api';
import { useSuspenseFeatureAccess } from '../../api/hooks/workspace/useSuspenseFeatureAccess';
import { useUpdateWorkspace } from '../../api/hooks/workspace/useUpdateWorkspace';
import { NotificationRulesController } from '../../features/NotificationRules';
import { useFeatureFlags } from '../../utils/featureFlags';
import { EmptyState } from '../EmptyState';
import { UpgradeButton } from './UpgradeButton';

export function MonitoringSettings() {
	const { workspace } = useAuthUser();
	const { mutateAsync: updateWorkspace } = useUpdateWorkspace(workspace.id);
	const { monitoringAccess } = useSuspenseFeatureAccess();
	const { monitorNotificationRules } = useFeatureFlags();

	if (!monitoringAccess) {
		return (
			<EmptyState
				title="Upgrade to access Monitoring"
				description="Monitoring is available on upgraded plans."
				illustrationName="upgrade"
				includeGoBack={false}
				stateHeight="50vh"
				size="lg"
				withActions={<UpgradeButton feature="Monitoring" size="md" />}
			/>
		);
	}

	const showNotificationRules =
		workspace?.monitoring_enabled && monitorNotificationRules;

	return (
		<Stack spacing={0}>
			<Box>
				<SettingsSwitch
					onChange={(checked) =>
						updateWorkspace({
							data: { id: workspace.id, monitoring_enabled: checked },
						})
					}
					checked={workspace?.monitoring_enabled ?? false}
					title="Monitoring"
					description="Turn on monitoring for this workspace"
				/>
			</Box>
			{showNotificationRules && (
				<Box mt="4xl">
					<NotificationRulesController />
				</Box>
			)}
		</Stack>
	);
}
